/** Ids are compared as strings against stored (lowercase) uuids, and zod's uuid check accepts uppercase, so every id is lowercased on the way in. */
export function lowercaseUuid(value) {
    return value.toLowerCase();
}
//# sourceMappingURL=lowercase-uuid.js.map